import { render } from "./gallery.vue?vue&type=template&id=527e165e"
import script from "./gallery.js?vue&type=script&lang=js&external"
export * from "./gallery.js?vue&type=script&lang=js&external"

import "./gallery.vue?vue&type=style&index=0&id=527e165e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__